let backendHost;

const hostname = window && window.location && window.location.hostname;

if (hostname === 'localhost') {
    backendHost = 'http://localhost:8080';
} else if (hostname === 'umbrel-dev' || hostname === 'order.tobermory.thewebpeople.ca') {
    backendHost = 'https://order.tobermory.thewebpeople.ca';
} else {
    backendHost = 'https://order.tobermorybrewingco.com';
}

export const API_ROOT = `${backendHost}/api`;